<template>
  <div>
    <Main ref="main" :loading="loading" :tableData="data">
      <template #header>
        <div
          class="d-flex align-items-stretch justify-content-between pl-3"
          style="border-left: 3px solid #409EFF;"
        >
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{
                $l('import_file_header') ||
                  '请你再次确认数据，如果数据有误请根据提示信息进行修改'
              }}
            </span>

            <el-divider direction="vertical" class="mx-3"></el-divider>

            <b-button size="sm" variant="outline-success" @click="download()">
              {{ $l('btn_download_template') || '下载模版' }}
            </b-button>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="upload()"
            >
              {{ $l('btn_choose_file') || '选择文件' }}
            </b-button>
          </div>

          <div>
            <el-button size="small" @click="cancel()">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button type="primary" size="small" @click="save()">
              {{ $l('INDEX.btn_confirm') || '确认' }}
            </el-button>
          </div>
        </div>
      </template>
    </Main>

    <ChooseImportTemplate
      :visible.sync="chooseTemplateOpts.visible"
      :templateQueryParams="{ templateGroup: 'nc-purchase-fabric-batch-group' }"
    />

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { VXETable } from 'vxe-table'
import EditLoading from '@/mixins/edit-loading'
import Main from './table.vue'
import ChooseImportTemplate from '@/views/factory/components/choose-import-template'
export default {
  components: { Main, ChooseImportTemplate },
  mixins: [EditLoading],
  data() {
    return {
      file: {},
      loading: false,
      data: [],
      chooseTemplateOpts: { visible: false },
      backDialogVisible: false,
    }
  },
  mounted() {},
  methods: {
    async load({ file, isSave = false, isUpdate = false } = {}) {
      if (!file) return false
      if (this.loading) return false

      this.file = file

      this.loading = true
      const res = await this.$api
        .purchaseFabricWithExcelBatchImportApi({ file, isSave, isUpdate })
        .catch(() => null)
      this.loading = false

      if (!res) return false

      const { status, msg, body } = res
      switch (status) {
        case 200:
          if (!isSave) this.data = body?.data || []

          return true
        case 203:
          this.data = body?.data || []
          this.$message.error('导入失败，请检查数据')
          return false
        case 204:
          this.$confirm(
            msg,
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            },
          )
            .then(() => this.save({ isUpdate: true }))
            .catch(() => this.$message({ type: 'info', message: '已取消导入' }))
          return false
        default:
          this.$message.error(msg)
          return false
      }
    },
    download() {
      this.chooseTemplateOpts = { visible: true }
    },
    async upload() {
      const types = ['xls', 'XLS', 'xlsx', 'XLSX']
      const { file } = await VXETable.readFile({ types }).catch(() => ({}))
      if (!file) return

      this.load({ file })
    },
    async save({ isUpdate = false } = {}) {
      if (this.loadingOpen()) return
      const result = await this.load({
        file: this.file,
        isSave: true,
        isUpdate,
      }).catch(() => false)
      this.loadingClose()

      if (!result) return (this.backDialogVisible = false)

      this.$emit('reload')
      this.close()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
